import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Table, Label, Button, Input, InputGroup } from 'reactstrap';
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from "material-icons-react";
import i18n from "../../../../i18next";
import Moment from 'moment';
import { extendMoment } from 'moment-range';

import {
    loadRestaurantSettings,
    loadOrderTypes,
    updateRestaurantSettings,
    dispatchErrorMessage,
    invalidSurveyPartnerFormMessage,
    invalidGiftCardProviderFormMessage,
    invalidSurveyGiftCardPartnerFormMessage
} from '../../../../actions/index';
import { MENUU_ADMIN, MENUU_MASTER_ADMIN } from '../../../../utils/Constants';
import { convertStringToBoolean, getCurrencySymbol } from '../../../../utils/CommonUtils';
import PreparationTimeScreen from './PreparationTimeScreen';
import AvField from 'availity-reactstrap-validation/lib/AvField';
import AvFeedback from 'availity-reactstrap-validation/lib/AvFeedback';
import SurveyPartnerScreen from './SurveyPartnerScreen';
import AddValueTimeExtensionsModal from './AddValueTimeExtensionsModal';
import GiftCardProviderScreen from './GiftCardProviderScreen';

class GeneralServicesScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orderTypes: [],
            defaultOrderType: {},
            preparationTimes: [],
            defaultPreparationTime: null,
            tipsEnabled: false,
            minimumDeliveryTip: null,
            deliveryTipInPercentage: false,
            disableFutureOrders: false,
            futureOrdersLimit: null,
            enableSmsOrderNotification: false,
            stateAlreadyCoppiedFromProps: false,
            preparationTimeScreenOpened: false,
            selectedPreparationTime: null,
            matchingDefaultOrderType: false,
            autoConfirmOrders: false,
            deferFutureOrder: false,
            phone: null,
            generalNote: '',
            customizedEmailNote: '',
            removedConfirmationSMS: false,
            timeSlotBased: false,
            timeSlotBufferTime: null,
            additionalFireTime: null,
            additionalMoneyCookTimes: [],
            currentValueTimeExtension: null,
            currentValueTimeExtensionIndex: null,
            addValueTimeExtensionsModalOpen: false,
            isaddValueTimeExtensionsChange: false,
            emailConfirmationNote: '',
            showMenuuLogo: false,
            enableLargeImageDesign: false
        };

        this.changeState = this.changeState.bind(this);
        this.changeCheckBoxState = this.changeCheckBoxState.bind(this);
        this.changeSelectedOrderTypesState = this.changeSelectedOrderTypesState.bind(this);
        this.updateRestaurantSettings = this.updateRestaurantSettings.bind(this);
        this.changeDefaultOrderTypeState = this.changeDefaultOrderTypeState.bind(this);
        this.negativeIntegersValidation = this.negativeIntegersValidation.bind(this);
        this.togglePreparationTimeScreen = this.togglePreparationTimeScreen.bind(this);
        this.addOrUpdatePreparationTime = this.addOrUpdatePreparationTime.bind(this);
    }

    componentDidMount() {
        this.props.loadOrderTypes();
        const restaurantId = this.props.match.params.id;
        this.props.loadRestaurantSettings(restaurantId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.serviceSettingsGeneral && this.props.serviceSettingsGeneral !== prevProps.serviceSettingsGeneral) {

            this.setState({
                ...this.state,
                orderTypes: this.props.serviceSettingsGeneral.orderTypes,
                defaultOrderType: this.props.serviceSettingsGeneral.defaultOrderType,
                preparationTimes: this.props.serviceSettingsGeneral.preparationTimes,
                defaultPreparationTime: this.props.serviceSettingsGeneral.defaultPreparationTime,
                tipsEnabled: this.props.serviceSettingsGeneral.tipsEnabled,
                minimumDeliveryTip: this.props.serviceSettingsGeneral.minimumDeliveryTip,
                deliveryTipInPercentage: this.props.serviceSettingsGeneral.deliveryTipInPercentage,
                disableFutureOrders: this.props.serviceSettingsGeneral.disableFutureOrders,
                futureOrdersLimit: this.props.serviceSettingsGeneral.futureOrdersLimit,
                enableSmsOrderNotification: this.props.serviceSettingsGeneral.enableSmsOrderNotification,
                autoConfirmOrders: this.props.serviceSettingsGeneral.autoConfirmOrders,
                deferFutureOrder: this.props.serviceSettingsGeneral.deferFutureOrder,
                phone: this.props.serviceSettingsGeneral.phone,
                stateAlreadyCoppiedFromProps: true,
                generalNote: this.props.serviceSettingsGeneral.generalNote,
                emailConfirmationNote: this.props.serviceSettingsGeneral.emailConfirmationNote ? this.props.serviceSettingsGeneral.emailConfirmationNote : '',
                removedConfirmationSMS: this.props.serviceSettingsGeneral.removedConfirmationSMS,
                timeSlotBased: this.props.serviceSettingsGeneral.timeSlotBased,
                timeSlotBufferTime: this.props.serviceSettingsGeneral.timeSlotBufferTime,
                additionalFireTime: this.props.serviceSettingsGeneral.additionalFireTime,
                additionalMoneyCookTimes: this.props.serviceSettingsGeneral.additionalMoneyCookTimes,
                showMenuuLogo: this.props.serviceSettingsGeneral.showMenuuLogo,
                enableLargeImageDesign: this.props.serviceSettingsGeneral.enableLargeImageDesign
            });
        }
    }

    copyStateFromProps() {
        if (this.props.serviceSettingsGeneral !== null && this.props.serviceSettingsGeneral !== undefined &&
            this.props.serviceSettingsGeneral.id !== undefined && this.state.stateAlreadyCoppiedFromProps === false) {

            this.setState({
                orderTypes: this.props.serviceSettingsGeneral.orderTypes,
                defaultOrderType: this.props.serviceSettingsGeneral.defaultOrderType,
                preparationTimes: this.props.serviceSettingsGeneral.preparationTimes,
                defaultPreparationTime: this.props.serviceSettingsGeneral.defaultPreparationTime,
                tipsEnabled: this.props.serviceSettingsGeneral.tipsEnabled,
                minimumDeliveryTip: this.props.serviceSettingsGeneral.minimumDeliveryTip,
                deliveryTipInPercentage: this.props.serviceSettingsGeneral.deliveryTipInPercentage,
                disableFutureOrders: this.props.serviceSettingsGeneral.disableFutureOrders,
                futureOrdersLimit: this.props.serviceSettingsGeneral.futureOrdersLimit,
                enableSmsOrderNotification: this.props.serviceSettingsGeneral.enableSmsOrderNotification,
                autoConfirmOrders: this.props.serviceSettingsGeneral.autoConfirmOrders,
                deferFutureOrder: this.props.serviceSettingsGeneral.deferFutureOrder,
                phone: this.props.serviceSettingsGeneral.phone,
                stateAlreadyCoppiedFromProps: true,
                generalNote: this.props.serviceSettingsGeneral.generalNote,
                emailConfirmationNote: this.props.serviceSettingsGeneral.emailConfirmationNote ? this.props.serviceSettingsGeneral.emailConfirmationNote : '',
                removedConfirmationSMS: this.props.serviceSettingsGeneral.removedConfirmationSMS,
                timeSlotBased: this.props.serviceSettingsGeneral.timeSlotBased,
                timeSlotBufferTime: this.props.serviceSettingsGeneral.timeSlotBufferTime,
                additionalFireTime: this.props.serviceSettingsGeneral.additionalFireTime,
                additionalMoneyCookTimes: this.props.serviceSettingsGeneral.additionalMoneyCookTimes,
                showMenuuLogo: this.props.serviceSettingsGeneral.showMenuuLogo,
                enableLargeImageDesign: this.props.serviceSettingsGeneral.enableLargeImageDesign
            });
        }
    }

    saveSurveyGiftCardSettings() {
        this.surveyPartnerRef.saveSurveyPartnerSettings();
        this.giftCardProviderRef.saveGiftCardProviderSettings(); 
    }

    updateRestaurantSettings() {
        const restaurantId = this.props.match.params.id;

        if (this.state.preparationTimeScreenOpened == true) {
            return;
        }

        this.props.updateRestaurantSettings(restaurantId, this.state, () => this.saveSurveyGiftCardSettings());

        this.setState({
            ...this.state,
            isaddValueTimeExtensionsChange: false
        })
    }

    changeState({ target }) {
        this.setState({
            ...this.state,
            [target.name]: target.value
        });
    }

    changeCheckBoxState({ target }) {
        this.setState({
            ...this.state,
            [target.name]: target.checked
        }, () => {
            if (target.name === 'deferFutureOrder' && !target.checked) {
                this.setState({
                    ...this.state,
                    additionalFireTime: 0
                })
            }
        });
    }

    changeDefaultOrderTypeState({ target }) {
        let selectedDefaultOrderType;
        for (let i = 0; i < this.props.orderTypes.length; i++) {
            let currentOrderType = this.props.orderTypes[i];
            if (currentOrderType.id == target.value) {
                selectedDefaultOrderType = currentOrderType;
                break;
            }
        }
        this.setState({
            ...this.state,
            defaultOrderType: selectedDefaultOrderType
        });
    }

    changeSelectedOrderTypesState({ target }) {
        let checked = convertStringToBoolean(target.checked);
        const newOrderTypes = this.state.orderTypes.slice(0);
        if (checked == true) {
            newOrderTypes.push({
                id: target.id,
                value: target.name
            });
        } else {
            let selectedOrderTypeIndex;
            for (let i = 0; i < newOrderTypes.length; i++) {
                const currentOrderType = newOrderTypes[i];
                if (currentOrderType.id == target.id) {
                    selectedOrderTypeIndex = i;
                    break;
                }
            }
            newOrderTypes.splice(selectedOrderTypeIndex, 1);
        }

        this.setState({
            ...this.state,
            orderTypes: newOrderTypes
        });
    }

    togglePreparationTimeScreen(selectedPreparationTime) {

        if (selectedPreparationTime !== undefined && selectedPreparationTime !== null &&
            selectedPreparationTime.validOnMonday !== undefined) {
            this.setState({
                ...this.state,
                preparationTimeScreenOpened: !this.state.preparationTimeScreenOpened,
                selectedPreparationTime: selectedPreparationTime
            });
        } else {
            this.setState({
                ...this.state,
                preparationTimeScreenOpened: !this.state.preparationTimeScreenOpened,
                selectedPreparationTime: null
            });
        }
    }

    addOrUpdatePreparationTime(preparationTime) {
        if (this.validateOverlappingPreparationTimes(preparationTime)) {
            let updatedPreparationTimes;

            if (preparationTime.id === undefined || preparationTime.id === null) {
                updatedPreparationTimes = this.state.preparationTimes.slice();
                preparationTime.id = updatedPreparationTimes.length + 1;
                updatedPreparationTimes.push(preparationTime);
            } else {
                updatedPreparationTimes = [];
                this.state.preparationTimes.map(currentPreparationTime => {
                    if (preparationTime.id === currentPreparationTime.id) {
                        updatedPreparationTimes.push(preparationTime);
                    } else {
                        updatedPreparationTimes.push(currentPreparationTime);
                    }
                });
            }

            this.setState({
                ...this.state,
                preparationTimes: updatedPreparationTimes,
                preparationTimeScreenOpened: !this.state.preparationTimeScreenOpened,
                selectedPreparationTime: null
            });

            return true;
        } else {
            this.props.dispatchErrorMessage(i18n.t('common:validations.overlapingPreparationTimes'));
            return false;
        }
    }

    validateOverlappingPreparationTimes(preparationTime) {
        const { preparationTimes } = this.state;
        for (let i = 0; i < preparationTimes.length; i++) {
            const currentPreparationTime = preparationTimes[i];
            if (preparationTime.id === currentPreparationTime.id) {
                continue;
            }

            if ((preparationTime.validOnMonday && currentPreparationTime.validOnMonday) ||
                (preparationTime.validOnTuesday && currentPreparationTime.validOnTuesday) ||
                (preparationTime.validOnWednesday && currentPreparationTime.validOnWednesday) ||
                (preparationTime.validOnThursday && currentPreparationTime.validOnThursday) ||
                (preparationTime.validOnFriday && currentPreparationTime.validOnFriday) ||
                (preparationTime.validOnSaturday && currentPreparationTime.validOnSaturday) ||
                (preparationTime.validOnSunday && currentPreparationTime.validOnSunday)) {

                const moment = extendMoment(Moment);
                let preparationTimeRange = moment.range(
                    moment(`${preparationTime.fromHour}:${preparationTime.fromMinute}`, 'HH:mm'),
                    moment(`${preparationTime.toHour}:${preparationTime.toMinute}`, 'HH:mm'));
                let currentPreparationTimeRange = moment.range(
                    moment(`${currentPreparationTime.fromHour}:${currentPreparationTime.fromMinute}`, 'HH:mm'),
                    moment(`${currentPreparationTime.toHour}:${currentPreparationTime.toMinute}`, 'HH:mm'));
                if (preparationTimeRange.overlaps(currentPreparationTimeRange) || preparationTimeRange.isSame(currentPreparationTimeRange)) { // Checks if it is same moment
                    return false;
                }
            }
        }

        return true;
    }

    deletePreparationTime(preparationTime) {
        const updatedPreparationTimes = [];

        this.state.preparationTimes.map(currentPreparationTime => {
            if (preparationTime.id !== currentPreparationTime.id) {
                updatedPreparationTimes.push(currentPreparationTime);
            }
        });

        this.setState({
            ...this.state,
            preparationTimes: updatedPreparationTimes
        });
    }

    renderProvidedSettings() {
        const { spaceBetween, headerStyle, rowStyler, columnGroup, selectPadding, zeroPadding,
            defaultService, defaultServiceFormGroup } = styles;

        return (
            <Col className="sectionStyle">
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="description" color="#000" size={20} color='#0288d1' />
                        <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.providedServices')}</span>
                    </div>
                </Row>
                <Row style={rowStyler}>
                    <Col sm={12} md={8} lg={8} style={columnGroup}>
                        {this.renderProvidedServicesContent()}
                    </Col>
                </Row>
                <Row>
                    <Col sm={8} md={6} style={zeroPadding}>
                        <AvGroup md={6} style={defaultServiceFormGroup}>
                            <Label sm={3} style={selectPadding} for="defaultOrderType">{i18n.t('screens:restaurantsMainContainer.defaultServices')}</Label>
                            <AvInput sm={9} style={defaultService}
                                type="select" name="defaultOrderType"
                                value={this.state.defaultOrderType.id} onChange={this.changeDefaultOrderTypeState}>
                                {this.renderDefaultOptions()}
                            </AvInput>
                        </AvGroup>
                    </Col>
                </Row>
            </Col>
        );
    }

    renderDefaultOptions() {
        const { orderTypes } = this.props;
        if (orderTypes !== null && orderTypes !== undefined) {
            return this.props.orderTypes.map((orderType, i) => {

                const transformToLocalize = () => { // Transforms item.value so it can be translated.
                    switch (orderType.value) {
                        case "Collection":
                            return i18n.t('screens:restaurantsMainContainer.collection');
                        case "Delivery":
                            return i18n.t('screens:restaurantsMainContainer.delivery');
                        case "Curbside":
                            return i18n.t('screens:restaurantsMainContainer.curbside');
                        case "In Store":
                            return i18n.t('screens:restaurantsMainContainer.instore');
                        case "Dine In":
                            return i18n.t('screens:restaurantsMainContainer.dinein')
                        default:
                            return;
                    }
                }

                return <option key={i} value={orderType.id}>{transformToLocalize(orderType.value)}</option>;
            });
        }
    }

    renderProvidedServicesContent() {
        const { checkboxInput } = styles;
        let { orderTypes } = this.props;

        if (orderTypes !== null && orderTypes !== undefined) {
            if (!(this.props.currentlyLoggedInUser.role === MENUU_MASTER_ADMIN || this.props.currentlyLoggedInUser.role === MENUU_ADMIN)) {
                orderTypes = orderTypes.filter(type => {
                    return type.value !== 'In Store'
                })
            }

            return orderTypes.map((orderType, i) => {

                const transformToLocalize = () => { // Transforms item.value so it can be translated.
                    switch (orderType.value) {
                        case "Collection":
                            return "collection";
                        case "Delivery":
                            return "delivery";
                        case "Dine In":
                            return "dinein"
                        case "Curbside":
                            return "curbside";
                        case "In Store":
                            return "instore"
                        default:
                            return;
                    }
                }

                return (
                    <InputGroup key={orderType.id + i} style={{ width: 'auto' }}>
                        <Label for={orderType.value}>{i18n.t(`screens:restaurantsMainContainer.${transformToLocalize(orderType.value)}`)}</Label>
                        <Input style={checkboxInput} type="checkbox" name={orderType.value} id={orderType.id}
                            checked={this.checkedIfMathes(orderType.id)}
                            onChange={this.changeSelectedOrderTypesState} />
                    </InputGroup>
                );
            });
        }
    }

    checkedIfMathes(orderTypeId) {
        const { orderTypes } = this.state;

        if (orderTypes !== undefined && orderTypes !== null && orderTypes.length > 0) {
            for (let i = 0; i < orderTypes.length; i++) {
                const currentOrderType = orderTypes[i];

                if (currentOrderType.id == orderTypeId) {
                    return true;
                }
            }
        }
        return false;
    }

    getValue(value) {
        return value || '';
    }

    renderTimeSlots() {
        const { preparationTimesHeader, headerStyle, spaceBetween, inputWithFixedWidth } = styles;

        return (
            <Col className="sectionStyle">
                <Row style={preparationTimesHeader}>
                    <div style={headerStyle}>
                        <MaterialIcon icon="schedule" color="#000" size={20} color='#0288d1' />
                        <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.timeSlots')}</span>
                    </div>
                </Row>

                <Row>
                    <Col sm={4}>
                        <AvGroup row style={{ marginLeft: 3, display: 'flex', alignItems: 'center' }}>
                            <Label className='col-form-label-left' for='timeSlotBased' >{i18n.t('screens:restaurantsMainContainer.timeSlotBased')}</Label>
                            <AvField
                                style={{ margin: '0 0 10px 10px' }} type='checkbox' name='timeSlotBased' id='timeSlotBased'
                                checked={this.state.timeSlotBased}
                                onChange={this.changeCheckBoxState}
                            />
                        </AvGroup>
                    </Col>

                    { <Col sm={4}>
                        <AvGroup row >
                            <Label className='col-form-label-left' for="timeSlotBufferTime" >{i18n.t('screens:restaurantsMainContainer.timeSlotBufferTime')}</Label>
                            <AvField
                                style={inputWithFixedWidth} type="number" name="timeSlotBufferTime" id="timeSlotBufferTime" placeholder="mm"
                                min={0} onKeyPress={(e) => this.negativeIntegersValidation(e)}
                                value={this.state.timeSlotBufferTime}
                                onChange={this.changeState}
                                disabled={!this.state.timeSlotBased}
                            />
                            <Label className='col-form-label-right' for="timeSlotBufferTime">{i18n.t('screens:preparationTimes.minutes')}</Label>
                        </AvGroup>
                    </Col> }
                </Row>
            </Col>
        );
    }

    renderLayoutSettingsOptions() {
        const { preparationTimesHeader, headerStyle, spaceBetween } = styles;

        //only visible for master admins
        const currUserRole = localStorage.getItem('role');
        if (currUserRole !== MENUU_MASTER_ADMIN && currUserRole !== MENUU_ADMIN) {
            return null;
        }

        return (
            <Col className="sectionStyle">
                <Row style={preparationTimesHeader}>
                    <div style={headerStyle}>
                        <MaterialIcon icon="visibility" color="#000" size={20} color='#0288d1' />
                        <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.layoutSettings')}</span>
                    </div>
                </Row>

                <Row>
                    <Col sm={6} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                        <Col sm={6} style={{ display: 'flex', alignItems: 'center'}}>
                        <AvGroup row style={{ marginLeft: 3, display: 'flex', alignItems: 'center' }}>
                            <Label className='col-form-label-left' for='enableLargeImageDesign' >{i18n.t('screens:restaurantsMainContainer.enableLargeImageDesign')}</Label>
                            <AvField
                                style={{ margin: '0 0 10px 10px' }} type='checkbox' name='enableLargeImageDesign' id='enableLargeImageDesign'
                                checked={this.state.enableLargeImageDesign}
                                onChange={this.changeCheckBoxState}
                            />
                        </AvGroup>
                        </Col>
                        {
                            currUserRole === MENUU_MASTER_ADMIN &&
                            <Col sm={6} style={{ display: 'flex', alignItems: 'center'}}>
                            <AvGroup row style={{ marginLeft: 3, display: 'flex', alignItems: 'center'}}>
                                <Label className='col-form-label-left' for='showMenuuLogo'>{i18n.t('screens:restaurantsMainContainer.showMenuuLogo')}</Label>
                                <AvField
                                    style={{ margin: '0 0 10px 10px' }} type='checkbox' name='showMenuuLogo' id='showMenuuLogo'
                                    checked={this.state.showMenuuLogo}
                                    onChange={this.changeCheckBoxState}
                                />
                            </AvGroup>
                            </Col>
                        }
                    </Col>
                </Row>
            </Col>
        );
    }

    renderPreparationTimes() {
        const { spaceBetween, headerStyle, preparationTimesHeader, inputWithFixedWidth, buttonStyle,
            paragraph, peakTimeRow, defaultPrepTimeGroup } = styles;

        return (
            <Col className="sectionStyle">
                <Row style={preparationTimesHeader}>
                    <div style={headerStyle}>
                        <MaterialIcon icon="schedule" color="#000" size={20} color='#0288d1' />
                        <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.prepTimes')}</span>
                    </div>
                </Row>
                <Row>
                    <Col sm={7}>
                        <AvGroup row style={defaultPrepTimeGroup}>
                            <Label className='col-form-label-left' for="defaultPreparationTime" >{i18n.t('screens:preparationTimes.defaultPrepTime')}</Label>
                            <AvField
                                style={inputWithFixedWidth} type="number" name="defaultPreparationTime" id="defaultPreparationTime" placeholder="mm"
                                min={1} onKeyPress={(e) => this.negativeIntegersValidation(e)}
                                value={this.getValue(this.state.defaultPreparationTime)}
                                onChange={this.changeState}
                                required={true}//disabled={this.state.timeSlotBased} 
                            />
                            <Label className='col-form-label-right' for="defaultPreparationTime">{i18n.t('screens:preparationTimes.minutes')}</Label>
                        </AvGroup>
                    </Col>
                    <Col sm={3} style={peakTimeRow} >
                        <Button
                            color="primary"
                            style={buttonStyle}
                            disabled={this.state.timeSlotBased}
                            onClick={this.togglePreparationTimeScreen}>
                            <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />&nbsp;{i18n.t('screens:preparationTimes.addPeakTime')}
                        </Button>
                    </Col>
                </Row>
                {this.renderPreparationTimesTable()}
                <Row>
                    <Col sm={9}>
                        <p style={paragraph}>{i18n.t('screens:preparationTimes.infoMsg')}</p>
                    </Col>
                </Row>
                <PreparationTimeScreen
                    preparationTime={this.state.selectedPreparationTime}
                    isOpen={this.state.preparationTimeScreenOpened}
                    onToggle={this.togglePreparationTimeScreen}
                    onSave={this.addOrUpdatePreparationTime}
                    preparationTimes={this.state.preparationTimes} />
            </Col>
        );
    }

    renderPreparationTimesTable() {
        const { preparationTimesTableStyle, preparationTimesTableInnerStyle } = styles;

        return (
            <Row>
                <Col sm={10} style={preparationTimesTableStyle}>
                    <Table responsive style={preparationTimesTableInnerStyle}>
                        <thead>
                            <tr>
                                <th style={{ backgroundColor: 'rgba(204, 204, 204, 0.24)' }}>{i18n.t('screens:preparationTimes.fromTo')}</th>
                                <th style={{ backgroundColor: 'rgba(204, 204, 204, 0.24)' }}>{i18n.t('screens:jobsHistoryScreen.duration')}</th>
                                <th style={{ backgroundColor: 'rgba(204, 204, 204, 0.24)' }}>{i18n.t('screens:preparationTimes.mon')}</th>
                                <th style={{ backgroundColor: 'rgba(204, 204, 204, 0.24)' }}>{i18n.t('screens:preparationTimes.tue')}</th>
                                <th style={{ backgroundColor: 'rgba(204, 204, 204, 0.24)' }}>{i18n.t('screens:preparationTimes.wed')}</th>
                                <th style={{ backgroundColor: 'rgba(204, 204, 204, 0.24)' }}>{i18n.t('screens:preparationTimes.thu')}</th>
                                <th style={{ backgroundColor: 'rgba(204, 204, 204, 0.24)' }}>{i18n.t('screens:preparationTimes.fri')}</th>
                                <th style={{ backgroundColor: 'rgba(204, 204, 204, 0.24)' }}>{i18n.t('screens:preparationTimes.sat')}</th>
                                <th style={{ backgroundColor: 'rgba(204, 204, 204, 0.24)' }}>{i18n.t('screens:preparationTimes.sun')}</th>
                                <th style={{ backgroundColor: 'rgba(204, 204, 204, 0.24)' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderPreparationTimesRows()}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        );
    }

    renderPreparationTimesRows() {
        const { preparationTimesButtonsColumnStyle } = styles;

        return this.state.preparationTimes.map((preparationTime, index) => {
            const prependTime = `${this.prependTimeWithZero(preparationTime.fromHour)}:${this.prependTimeWithZero(preparationTime.fromMinute)} -
                                 ${this.prependTimeWithZero(preparationTime.toHour)}:${this.prependTimeWithZero(preparationTime.toMinute)}`;
            return (
                <tr key={index}>
                    <td>{prependTime}</td>
                    <td>{preparationTime.duration}{i18n.t('screens:preparationTimes.min')}</td>
                    <td>{this.renderPreparationTimeDayColumn(preparationTime.validOnMonday)}</td>
                    <td>{this.renderPreparationTimeDayColumn(preparationTime.validOnTuesday)}</td>
                    <td>{this.renderPreparationTimeDayColumn(preparationTime.validOnWednesday)}</td>
                    <td>{this.renderPreparationTimeDayColumn(preparationTime.validOnThursday)}</td>
                    <td>{this.renderPreparationTimeDayColumn(preparationTime.validOnFriday)}</td>
                    <td>{this.renderPreparationTimeDayColumn(preparationTime.validOnSaturday)}</td>
                    <td>{this.renderPreparationTimeDayColumn(preparationTime.validOnSunday)}</td>
                    <td style={preparationTimesButtonsColumnStyle}>
                        <Button
                            color="link"
                            disabled={this.state.timeSlotBased}
                            onClick={() => this.togglePreparationTimeScreen(preparationTime)}>
                            <MaterialIcon icon="edit" color="rgb(2, 136, 209)" size={28} />
                        </Button>
                        <Button
                            color="link"
                            disabled={this.state.timeSlotBased}
                            onClick={() => this.deletePreparationTime(preparationTime)}>
                            <MaterialIcon icon="delete" color="rgb(2, 136, 209)" size={28} />
                        </Button>
                    </td>
                </tr>
            );
        });
    }

    prependTimeWithZero(timeValue) {
        if (timeValue < 10) {
            return `0${timeValue}`
        } else {
            return timeValue;
        }
    }

    renderPreparationTimeDayColumn(validOnThatDay) {
        if (validOnThatDay) {
            return (
                <MaterialIcon icon="check" color="rgb(117, 159, 46)" size={28} />
            );
        } else {
            return null;
        }
    }

    renderOrderValueTimeExtensions() {
        const { spaceBetween, headerStyle, buttonStyle, rowStyler } = styles;

        return (
            <Col className="sectionStyle">
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="schedule" color="#000" size={20} color='#0288d1' />
                        <span style={spaceBetween}>{i18n.t('screens:generalScreen.orderValueTimeExtensions')}</span>
                    </div>
                </Row>
                <Row style={rowStyler}>
                    <div style={{ display: 'flex', width: '83.1%', justifyContent: 'space-between' }}>
                        <div>{this.renderAllCookTimeExtensions()}</div>
                        <div></div>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <Button
                                color="primary"
                                style={{ ...buttonStyle, marginBottom: 0 }}
                                onClick={this.toggleAddValueTimeExtensionsModal}>
                                <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.addExtension')}
                            </Button>
                            <p style={{ color: '#dc3545', fontSize: '80%'}} hidden={!this.state.isaddValueTimeExtensionsChange}>
                                {i18n.t('common:validations.saveWarningMsg')}
                            </p>
                        </div>
                    </div>
                </Row>

                {
                    this.state.addValueTimeExtensionsModalOpen ?
                        <AddValueTimeExtensionsModal
                            isOpen={this.state.addValueTimeExtensionsModalOpen}
                            currentValueTimeExtension={this.state.currentValueTimeExtension}
                            currentValueTimeExtensionIndex={this.state.currentValueTimeExtensionIndex}
                            onToggle={this.toggleAddValueTimeExtensionsModal}
                            currency={this.props.restaurant.currency}
                            onSave={this.addOrUpdateExtension}
                        />
                        : null
                }
            </Col>
        );
    }

    renderAllCookTimeExtensions() {
        const additionalMoneyCookTimesCopy = [...this.state.additionalMoneyCookTimes];

        return additionalMoneyCookTimesCopy
            .sort((a, b) => Number(a.money) > Number(b.money) ? 1 : -1)
            .map((element) => {
                const index = this.state.additionalMoneyCookTimes.indexOf(element)
                return (
                    <div key={element.id} style={{ display: 'flex' }}>
                        <AvGroup style={{ display: 'flex', alignItems: 'center', marginRight: 50 }}>
                            <Label style={{ margin: '0px 20px 0px 0px', minWidth: 70 }}>{i18n.t('common:form.over')}</Label>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <AvInput
                                    style={{ marginRight: 20, minWidth: 50 }}
                                    type="text"
                                    name="money"
                                    disabled={true}
                                    value={element.money}
                                />
                                <span>{getCurrencySymbol(this.props.restaurant.currency)}</span>
                            </div>
                        </AvGroup>
                        <AvGroup style={{ display: 'flex', alignItems: 'center' }}>
                            <Label style={{ margin: '0px 20px 0px 0px', minWidth: 100 }}>{i18n.t('common:form.cookTime')}</Label>
                            <AvInput
                                style={{ minWidth: 50 }}
                                type='text'
                                name='minutes'
                                disabled={true}
                                value={element.minutes}
                            />
                            <span style={{ margin: '0px 20px 0px 20px' }}>{i18n.t('screens:preparationTimes.minutes')}</span>
                        </AvGroup>
                        <Button
                            color="link"
                            onClick={(event) => this.toggleAddValueTimeExtensionsModal(event, element, index)}>
                            <MaterialIcon icon="edit" color="rgb(2, 136, 209)" size={28} />
                        </Button>
                    </div>
                )
            })
    }

    toggleAddValueTimeExtensionsModal = (event, currentExtension, index) => {
        if (!currentExtension) {
            this.setState({
                ...this.state,
                addValueTimeExtensionsModalOpen: !this.state.addValueTimeExtensionsModalOpen,
                currentValueTimeExtension: null,
                currentValueTimeExtensionIndex: null
            })
        } else {
            this.setState({
                ...this.state,
                addValueTimeExtensionsModalOpen: !this.state.addValueTimeExtensionsModalOpen,
                currentValueTimeExtension: currentExtension,
                currentValueTimeExtensionIndex: index
            })
        }
    }

    addOrUpdateExtension = (extension, selectedTypeIndex, isDelete) => {
        if (!extension.id && !selectedTypeIndex) {
            this.setState({
                ...this.state,
                additionalMoneyCookTimes: [...this.state.additionalMoneyCookTimes, { money: extension.money, minutes: extension.minutes }],
                isaddValueTimeExtensionsChange: true
            }, () => this.toggleAddValueTimeExtensionsModal())
        } else {
            let additionalMoneyCookTimesCopy = [...this.state.additionalMoneyCookTimes];
            if (isDelete) {
                additionalMoneyCookTimesCopy = additionalMoneyCookTimesCopy.filter((moneyCookTime, i) => {
                    if (extension.id) {
                        return moneyCookTime.id !== extension.id
                    }
                    return selectedTypeIndex !== i;
                })
            } else {
                additionalMoneyCookTimesCopy = additionalMoneyCookTimesCopy.map((moneyCookTime, i) => {
                    if (moneyCookTime.id === extension.id && extension.id) {
                        moneyCookTime.money = extension.money;
                        moneyCookTime.minutes = extension.minutes;
                    } else if (selectedTypeIndex === i) {
                        moneyCookTime.money = extension.money;
                        moneyCookTime.minutes = extension.minutes;
                    }
                    return moneyCookTime;
                })
            }
            this.setState({
                ...this.state,
                additionalMoneyCookTimes: additionalMoneyCookTimesCopy,
                isaddValueTimeExtensionsChange: true
            }, () => this.toggleAddValueTimeExtensionsModal())
        }
    }

    renderTips() {
        const { spaceBetween, headerStyle, displayFlex, formGroup, checkboxInput, rowStyler,
            validationFieldInput, currencyTypeStyle, inputFieldFormGroup, inputFieldLabel } = styles;

        const isDisabled = this.state.tipsEnabled ? false : true;
        const minValue = !this.state.tipsEnabled ? -1 : (!this.state.deliveryTipInPercentage ? 0.01 : 1);
        const currencyType = this.state.deliveryTipInPercentage ? "%" : getCurrencySymbol(this.props.restaurant.currency);

        return (
            <Col className="sectionStyle">
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="local_atm" color="#000" size={20} color='#0288d1' />
                        <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.tips')}</span>
                    </div>
                </Row>
                <Row style={rowStyler}>
                    <Col style={displayFlex}>
                        <AvGroup row style={formGroup}>
                            <Label for="tipsEnabledId" >{i18n.t('screens:restaurantsMainContainer.tipsEnabled')}</Label>
                            <AvInput style={checkboxInput} type="checkbox" name="tipsEnabled" id="tipsEnabledId"
                                checked={this.state.tipsEnabled} onChange={this.changeCheckBoxState} />
                        </AvGroup>
                        <AvGroup row style={inputFieldFormGroup} className="inputFieldValidation" >
                            <Label style={inputFieldLabel} for="minimumDeliveryTip" >{i18n.t('screens:restaurantsMainContainer.minDeliveryTip')}</Label>
                            <AvField
                                style={validationFieldInput} type="number" name="minimumDeliveryTip" id="minDeliveryTipId"
                                min={minValue} onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                value={this.state.minimumDeliveryTip ? this.state.minimumDeliveryTip : ''} onChange={this.changeState}
                                disabled={isDisabled} />
                            <Label style={currencyTypeStyle}>{currencyType}</Label>
                        </AvGroup>
                        <AvGroup row style={formGroup} >
                            <Label for="tipInPercentId" >{i18n.t('screens:restaurantsMainContainer.tipInPercent')}</Label>
                            <AvInput style={checkboxInput} type="checkbox" name="deliveryTipInPercentage" id="tipInPercentId"
                                checked={this.state.deliveryTipInPercentage} disabled={isDisabled}
                                onChange={this.changeCheckBoxState} />
                        </AvGroup>
                    </Col>
                </Row>
            </Col>
        );
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    renderFireTimeOptions() {
        const minutes = [0, 10, 20, 30, 40, 50, 60];
        return minutes.map(minute => {
            return (
                <option value={minute}>{minute}</option>
            )
        })
    }

    renderFutureOrders() {
        const { spaceBetween, headerStyle, rowStyler, displayFlex, formGroup, checkboxInput,
            limitDays, inputFieldFormGroup, inputFieldLabel, validationFieldInput, defaultServiceFormGroup, selectPadding } = styles;

        const isDisabled = this.state.disableFutureOrders ? true : false;
        const minValue = this.state.disableFutureOrders ? -1 : 1;

        return (
            <Col className="sectionStyle">
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="description" color="#000" size={20} color='#0288d1' />
                        <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.futureOrders')}</span>
                    </div>
                </Row>
                <Row style={rowStyler}>
                    <Col style={displayFlex}>
                        <AvGroup row style={formGroup}>
                            <Label for="disableFutureOrders" >{i18n.t('screens:restaurantsMainContainer.disableFutureOrders')}</Label>
                            <AvInput style={checkboxInput} type="checkbox" name="disableFutureOrders"
                                checked={this.state.disableFutureOrders} onChange={this.changeCheckBoxState} />
                        </AvGroup>
                        <AvGroup row style={inputFieldFormGroup} className="inputFieldValidation">
                            <Label style={inputFieldLabel} for="futureOrdersLimit" >{i18n.t('screens:restaurantsMainContainer.limitDays')}</Label>
                            <AvField
                                style={validationFieldInput} type="number" name="futureOrdersLimit" id="limitDaysId"
                                min={minValue} disabled={isDisabled} onKeyPress={(e) => this.negativeIntegersValidation(e)}
                                value={this.state.futureOrdersLimit} onChange={this.changeState} required={!isDisabled} />
                            <Label style={limitDays} for="limitDaysId">{i18n.t('screens:restaurantsMainContainer.days')}</Label>
                        </AvGroup>
                        {/* <AvGroup row style={inputFieldFormGroup} className="inputFieldValidation">
                            <Label style={inputFieldLabel} for="fireDuration" >{i18n.t('screens:restaurantsMainContainer.fireDuration')}</Label>
                            <AvField
                                style={validationFieldInput} type="number" name="fireDuration" id="fireDurationId"
                                min={minValue}
                                disabled={isDisabled}
                                onKeyPress={(e) => this.negativeIntegersValidation(e)}
                                onChange={this.changeState}
                                required={!isDisabled}
                                value={this.state.fireDuration} />
                            <Label style={limitDays} for="fireDurationId">
                                {i18n.t('screens:restaurantsMainContainer.minutes')}
                            </Label>
                        </AvGroup> */}
                        <AvGroup row style={formGroup} >
                            <Label for="autoConfirmOrders">{i18n.t('screens:restaurantsMainContainer.autoConfirmOrders')}</Label>
                            <AvInput style={checkboxInput}
                                type="checkbox" name="autoConfirmOrders" checked={this.state.autoConfirmOrders} onChange={this.changeCheckBoxState}
                            />
                        </AvGroup>
                        <AvGroup row style={formGroup} >
                            <Label for="deferFutureOrder" >{i18n.t('screens:restaurantsMainContainer.deferFutureOrder')}</Label>
                            <AvInput style={checkboxInput} disabled={isDisabled}
                                type="checkbox" name="deferFutureOrder" checked={this.state.deferFutureOrder} onChange={this.changeCheckBoxState}
                            />
                        </AvGroup>
                        <AvGroup hidden={!this.state.deferFutureOrder} row style={inputFieldFormGroup} className="inputFieldValidation">
                            <Label style={inputFieldLabel} for="additionalFireTime" >{i18n.t('screens:restaurantsMainContainer.fireTime')}</Label>
                            <AvField
                                style={validationFieldInput} type="select" name="additionalFireTime" id="additionalFireTime"
                                value={this.state.additionalFireTime} onChange={this.changeState} >
                                {this.renderFireTimeOptions()}
                            </AvField>
                            <Label style={limitDays} for="limitDaysId">{i18n.t('screens:restaurantsMainContainer.minutes')}</Label>
                        </AvGroup>
                    </Col>
                </Row>
            </Col>
        );
    }

    negativeIntegersValidation(e) {

        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 45 || inputKeyCode == 46 || inputKeyCode == 43
                || inputKeyCode == 69 || inputKeyCode == 101) {
                e.preventDefault();
            }
        }
    }

    invalidFormMessage() {
        if(this.surveyPartnerRef.state.toSaveSurveyPartner && !this.giftCardProviderRef.state.toSaveGiftCardProvider) {
            this.props.invalidSurveyPartnerFormMessage();
        } else if(this.giftCardProviderRef.state.toSaveGiftCardProvider && !this.surveyPartnerRef.state.toSaveSurveyPartner) {
            this.props.invalidGiftCardProviderFormMessage();
        } else if (this.surveyPartnerRef.state.toSaveSurveyPartner && this.giftCardProviderRef.state.toSaveGiftCardProvider) {
            this.props.invalidSurveyGiftCardPartnerFormMessage();
        }
    }

    renderNotificationSettings() {
        const { headerStyle, spaceBetween, rowStyler, displayFlex, formGroup, checkboxInput } = styles;
        
        return (
            <Col className="sectionStyle">
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon='description' color='#000' size={20} color='#0288d1' />
                        <span style={spaceBetween}>{i18n.t('screens:mainContainer.notifications')}</span>
                    </div>
                </Row>
                <Row style={rowStyler}>
                    <Col style={displayFlex}>
                        <AvGroup row style={formGroup}>
                            <Label for='removedConfirmationSMS'>{i18n.t('screens:restaurantsMainContainer.removedConfirmationSMS')}</Label>
                            <AvInput style={checkboxInput} type='checkbox' name='removedConfirmationSMS'
                                checked={this.state.removedConfirmationSMS} onChange={this.changeCheckBoxState} />
                        </AvGroup>
                    </Col>
                </Row>
                <Row style={rowStyler}>
                    <Col style={displayFlex}>
                        <AvGroup row style={formGroup}>
                            <Label for='enableSmsOrderNotification'>{i18n.t('screens:restaurantsMainContainer.enableSmsOrderNotification')}</Label>
                            <AvInput style={checkboxInput} type='checkbox' name='enableSmsOrderNotification'
                                checked={this.state.enableSmsOrderNotification} onChange={this.changeCheckBoxState} />
                        </AvGroup>
                    </Col>
                    <Col>
                        <AvGroup row style={formGroup}>
                            <Label for='phone' style={{ display: 'flex', alignSelf: 'center' }}>{i18n.t('common:form.phone')}</Label>
                            <AvInput style={{ maxWidth: 250, marginLeft: 10 }}
                                type='phone' name='phone' placeholder={i18n.t('screens:restaurantsMainContainer.phonePlaceholder')}
                                value={this.state.phone}
                                onChange={this.changeState} required={this.state.enableSmsOrderNotification}
                            />
                            <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                        </AvGroup>
                    </Col>
                </Row>
            </Col>
        );
    }

    renderGeneralNote() {
        const { headerStyle, spaceBetween } = styles;

        return (
            <Col className="sectionStyle">
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="speaker_notes" size={20} color='#0288d1' />
                        <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.generalNotes')}</span>
                    </div>
                </Row>
                <Row>
                    <AvGroup row style={{ width: '100%', marginTop: 10 }}>
                        <AvInput style={{ width: 'calc(83% - 10px)', marginLeft: 20, height: 100, resize: 'none' }}
                            type="textarea" name="generalNote" placeholder={i18n.t('screens:restaurantsMainContainer.generalNotesPlaceholder')}
                            value={this.state.generalNote}
                            onChange={this.changeState}
                        />
                    </AvGroup>
                </Row>
            </Col>
        );
    }

    renderEmailConfirmationNotes() {
        const { headerStyle, spaceBetween, inputCounter } = styles;
        const { emailConfirmationNote } = this.state;

        return (
            <Col className="sectionStyle">
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="email" size={20} color='#0288d1' />
                        <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.emailConfirmationNotes')}</span>
                    </div>
                </Row>
                <Row>
                    <AvGroup row style={{ width: '100%', marginTop: 10 }}>
                        <AvInput style={{ width: 'calc(83% - 10px)', marginLeft: 20, height: 100, resize: 'none' }}
                            type="textarea" name="emailConfirmationNote" placeholder={i18n.t('screens:restaurantsMainContainer.emailConfirmationNotePlaceholder')}
                            value={emailConfirmationNote}
                            onChange={this.changeState}
                            maxLength={1024}
                            errorMessage={i18n.t('common:validations.errorMsg')} />
                    </AvGroup>
                    <div style={inputCounter}> {emailConfirmationNote !== undefined && emailConfirmationNote !== null ? 1024 - emailConfirmationNote.length : 1024} {i18n.t('screens:restaurantsMainContainer.of')} 1024</div>
                </Row>
            </Col>
        );
    }

    renderSaveButton() {
        const { buttonStyle, spaceBetween } = styles;

        return (
            <Row>
                <Col>
                    <Button color="primary" sm={12} style={buttonStyle} >
                        <MaterialIcon icon="save" color="#fff" size={18} /><span style={spaceBetween}>{i18n.t('common:buttons.save')}</span>
                    </Button>
                </Col>
            </Row>
        );
    }

    render() {
        this.copyStateFromProps();

        const { errorContainerStyle, errorMessage } = styles;
        const currUserRole = localStorage.getItem('role');

        if (Number(this.props.match.params.id) !== -1) {
            return (
                <div>
                    <Col>
                        <AvForm onValidSubmit={this.updateRestaurantSettings} onInvalidSubmit={() => this.invalidFormMessage()} style={styles.formStyle}>
                            {this.renderProvidedSettings()}
                            {this.renderTimeSlots()}
                            {this.renderPreparationTimes()}
                            {this.renderOrderValueTimeExtensions()}
                            {this.renderTips()}
                            {this.renderFutureOrders()}
                            {
                            currUserRole === MENUU_ADMIN || currUserRole === MENUU_MASTER_ADMIN ? 
                            this.renderNotificationSettings() : null
                            }
                            <SurveyPartnerScreen onRef={ref => (this.surveyPartnerRef = ref)} />
                            {
                            currUserRole === MENUU_ADMIN || currUserRole === MENUU_MASTER_ADMIN ? 
                            <GiftCardProviderScreen onRef={ref => (this.giftCardProviderRef = ref)} /> : null
                            }
                            {this.renderGeneralNote()}
                            {this.renderEmailConfirmationNotes()}
                            {this.renderLayoutSettingsOptions()}
                            {this.renderSaveButton()}
                        </AvForm>
                    </Col>
                </div>
            );
        } else {

            return (
                <div style={errorContainerStyle} className="errorIcon">
                    <h5 style={errorMessage}>{i18n.t('common:validations.settingsFirstMsg')}</h5>
                    <MaterialIcon icon="warning" color="#dbdadb" size={40} />
                </div>
            );
        }


    }
}

const mapStateToProps = (state) => {
    return {
        serviceSettingsGeneral: state.serviceSettingsGeneral,
        orderTypes: state.orderTypes,
        restaurant: state.restaurant,
        currentlyLoggedInUser: state.user,
    }
}

export default connect(
    mapStateToProps,
    {
        loadRestaurantSettings,
        loadOrderTypes,
        updateRestaurantSettings,
        dispatchErrorMessage,
        invalidSurveyPartnerFormMessage,
        invalidGiftCardProviderFormMessage,
        invalidSurveyGiftCardPartnerFormMessage
    }
)(GeneralServicesScreen);

const styles = {
    errorContainerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #c93a11',
        paddingBottom: 10,
        paddingTop: 60,
        paddingLeft: 15,
        height: 200,
        textAlign: 'center',
    },
    errorMessage: {
        color: "#c3c3c3",
    },
    spaceBetween: {
        paddingLeft: 4
    },
    formStyle: {
        width: '103.3%'
    },
    headerStyle: {
        paddingLeft: 0,
        borderBottom: "1px solid rgb(222, 226, 230)",
        marginBottom: 15,
        color: '#0088d1',
        width: 400
    },
    buttonStyle: {
        float: 'right',
        marginBottom: 10
    },
    rowStyler: {
        marginTop: 10,
        marginBottom: 10,
        paddingLeft: 15
    },
    displayFlex: {
        display: "flex",
        height: 80
    },
    columnGroup: {
        display: 'flex',
        justifyContent: "space-between",
        paddingLeft: 0,
        marginRight: 15
    },
    formGroup: {
        alignSelf: 'center',
        marginRight: 40
    },
    inputFieldFormGroup: {
        alignItems: 'center',
        height: 80,
        marginRight: 40
    },
    limitDays: {
        alignSelf: 'center',
        paddingRight: 10,
        paddingBottom: 10
    },
    inputFieldLabel: {
        alignSelf: 'center',
        paddingRight: 10,
        paddingLeft: 5,
        paddingBottom: 10
    },
    currencyTypeStyle: {
        alignSelf: 'center',
        paddingRight: 10,
        paddingLeft: 5,
        marginBottom: 16,
        width: 50
    },
    selectPadding: {
        padding: "7px 0 7px 0"
    },
    zeroPadding: {
        paddingLeft: 0
    },
    defaultService: {
        width: 290
    },
    defaultServiceFormGroup: {
        display: "flex",
        marginLeft: 15
    },
    checkboxInput: {
        position: "relative",
        marginLeft: 10
    },
    validationFieldInput: {
        width: 80,
        marginRight: 21
    },
    preparationTimesHeader: {
        marginBottom: 20
    },
    inputWithFixedWidth: {
        width: 80,
        marginRight: 21
    },
    preparationTimesTableStyle: {
        paddingLeft: 0,
        paddingRight: 0,
        marginLeft: 10
    },
    preparationTimesTableInnerStyle: {
        marginTop: 10,
    },
    preparationTimesButtonsColumnStyle: {
        width: '140px',
        textAlign: 'center'
    },
    paragraph: {
        fontSize: 14,
        display: "flex",
        justifyContent: 'flex-end'
    },
    peakTimeRow: {
        paddingRight: 0
    },
    defaultPrepTimeGroup: {
        height: 68,
        marginRight: 40,
        marginLeft: 3
    },
    inputCounter: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: 'calc(83% - 10px)',
        fontSize: 12
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/GeneralServicesScreen.js